/**
 * Error Boundary for Chat — catches Twilio SDK errors (e.g. Twilsock timeout)
 * and shows a fallback UI instead of crashing.
 */
import React from "react";

class ChatErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    // Suppress Twilsock timeout errors - don't set hasError state for these
    const errorMessage = error?.message || error?.toString() || '';
    if (/Twilsock.*request timeout|TM[0-9a-f-]{8,}|_conversationsPromise/i.test(errorMessage)) {
      return { hasError: false }; // Don't trigger error UI
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress Twilsock timeout errors - they're expected Twilio SDK behavior
    const errorMessage = error?.message || error?.toString() || '';
    if (/Twilsock.*request timeout|TM[0-9a-f-]{8,}|_conversationsPromise/i.test(errorMessage)) {
      // Don't log or show Twilsock timeout errors
      return;
    }
    console.error("[ChatErrorBoundary]", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div className="py-6 px-4 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 text-sm">
          Chat connection timed out. Check your network and ensure the Twilio proxy server is running.
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChatErrorBoundary;
